import APIClient from '@/shared/http/clients/api'

const resourceName = 'brand'
const APIRegAuto = process.env.APIBaseURLRegulationAuto

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetAllByAutoTypeID = (autotypeid, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/autotype/${autotypeid}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIRegAuto}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIRegAuto}/${resourceName}/${id}`, config)

const BrandRepository = {
  GetAll,
  GetAllPaging,
  GetAllByAutoTypeID,
  GetById,
  Create,
  Update,
  Delete
}

export default BrandRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configuration/brand.js